let spritePromise = null;
const symbols = new Map();

function loadSprite() {
    if (!spritePromise) {
        const path = window.app_config?.svgSpritePath || '';
        spritePromise = (
            path
                ? fetch(path).then((response) => {
                      if (!response.ok) throw new Error(`HTTP ${response.status}`);
                      return response.text();
                  })
                : Promise.reject(new Error('window.app_config.svgSpritePath is not set'))
        )
            .then((xml) => {
                const doc = new DOMParser().parseFromString(xml, 'image/svg+xml');
                for (const symbol of doc.querySelectorAll('symbol[id]')) {
                    symbols.set(symbol.id, symbol);
                }
            })
            .catch((error) => {
                console.warn(`svg sprite "${path}" could not be loaded, all icons stay empty:`, error);
            });
    }
    return spritePromise;
}

export async function getSpriteSymbol(id) {
    await loadSprite();
    return symbols.get(id) || null;
}
